import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { map } from 'rxjs/operators';
import { IPerfilInversion } from '../data/actualizacion-datos/perfilamiento.model';
import { ICuc } from '../user/user-requests.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private store: StorageMap) {}

  storeCucs(input: ICuc[]) {
    return this.store.set('userCUCS', input).pipe();
  }

  storeActiveCUC(input: ICuc) {
    return this.store.set('activeCUC', input).pipe();
  }

  storeUserSession(input) {
    return this.store.set('userSession', input).pipe();
  }

  storeUserData(input) {
    return this.store.set('userData', input).pipe();
  }

  storeLastSession(input) {
    return this.store.set('lastActive', input).pipe();
  }

  storeUserProcess(input) {
    return this.store.set('loginProcess', input).pipe();
  }

  storeUserParametria(input) {
    return this.store.set('userParametria', input).pipe();
  }

  storePerfilamientoData<T = IPerfilInversion>(input: T, key: string) {
    return this.store.set(key, input).pipe();
  }

  getPerfilamientoData<T = IPerfilInversion>(key: string) {
    return this.store.get(key).pipe(
      map((value) => value as T | undefined)
    );
  }

  deletePerfilamientoData(key: string) {
    return this.store.delete(key).pipe();
  }

  deleteUserProcess() {
    return this.store.delete('loginProcess').pipe();
  }

  storeActiveDatosAct() {
    return this.store.set('activeDatosAct', true).pipe();
  }

  deleteActiveDatosAct() {
    return this.store.delete('activeDatosAct').pipe();
  }

  get getActiveDatosAct() {
    return this.store.get('activeDatosAct').pipe();
  }

  reset() {
    this.store.clear().subscribe();
  }

  get userData() {
    return this.store.get('userData').pipe();
  }

  get userProcess() {
    return this.store.get('loginProcess').pipe();
  }

  get listCUCS() {
    return this.store.get('userCUCS').pipe();
  }

  get activeCUC() {
    return this.store.get('activeCUC').pipe();
  }

  get getSession() {
    return this.store.get('userSession').pipe();
  }

  get userParametria() {
    return this.store.get('userParametria').pipe();
  }

  get getLastSession() {
    return this.store.get('lastActive').pipe();
  }
}
